<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import WootSnackbar from './Snackbar.vue';
import { emitter } from 'shared/helpers/mitt';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  duration: {
    type: Number,
    default: 2500,
  },
});

const { t } = useI18n();

const snackMessages = ref([]);
const snackbarContainer = ref(null);

const showPopover = () => {
  try {
    const el = snackbarContainer.value;
    if (el?.matches(':popover-open')) {
      el.hidePopover();
    }
    el?.showPopover();
  } catch (e) {
    // ignore
  }
};

const onNewToastMessage = ({ message: originalMessage, action }) => {
  const message = action?.usei18n ? t(originalMessage) : originalMessage;
  const duration = action?.duration || props.duration;

  snackMessages.value.push({
    key: Date.now(),
    message,
    action,
  });

  nextTick(showPopover);

  setTimeout(() => {
    snackMessages.value.shift();
  }, duration);
};

onMounted(() => {
  emitter.on('newToastMessage', onNewToastMessage);
});

onUnmounted(() => {
  emitter.off('newToastMessage', onNewToastMessage);
});
</script>

<template>
  <div
    ref="snackbarContainer"
    popover="manual"
    class="fixed top-4 left-1/2 -translate-x-1/2 max-w-[25rem] w-[calc(100%-2rem)] text-center bg-transparent border-0 p-0 m-0 outline-none overflow-visible"
  >
    <transition-group name="toast-fade" tag="div">
      <WootSnackbar
        v-for="snackMessage in snackMessages"
        :key="snackMessage.key"
        :message="snackMessage.message"
        :action="snackMessage.action"
      />
    </transition-group>
  </div>
</template>

<style scoped>
/* SiteUp: o transition-group "toast-fade" sempre foi referenciado mas nunca
   teve CSS — o toast piscava em corte seco. Curvas dos motion tokens. */
.toast-fade-enter-active {
  transition:
    opacity var(--motion-duration-enter) var(--motion-ease-out),
    transform var(--motion-duration-enter) var(--motion-ease-out);
}
.toast-fade-leave-active {
  transition:
    opacity var(--motion-duration-hover) var(--motion-ease-out),
    transform var(--motion-duration-hover) var(--motion-ease-out);
  position: absolute;
  inset-inline: 0;
}
.toast-fade-enter-from {
  opacity: 0;
  transform: translateY(-0.5rem) scale(0.96);
}
.toast-fade-leave-to {
  opacity: 0;
  transform: translateY(-0.25rem) scale(0.98);
}
.toast-fade-move {
  transition: transform var(--motion-duration-layout) var(--motion-ease-spring);
}
</style>
